import { render, staticRenderFns } from "./DepthLearn.vue?vue&type=template&id=7bce34b0&scoped=true&"
import script from "./DepthLearn.vue?vue&type=script&lang=js&"
export * from "./DepthLearn.vue?vue&type=script&lang=js&"
import style0 from "./DepthLearn.vue?vue&type=style&index=0&id=7bce34b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce34b0",
  null
  
)

export default component.exports